import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreationDynamicComponentComponent } from './creation-dynamic-component.component';
import { CreationFormComponent } from './creation-form/creation-form.component';
import { ViewFormComponent } from './view-form/view-form.component';
import { AssociationTaskFormsComponent } from './association-task-forms/association-task-forms.component';
import { ConditionsComponent } from './conditions/conditions.component';
import { OperationsFormComponent } from './creation-form/operations-form/operations-form.component';
import {
  CreationOperationComponent
} from './creation-form/operations-form/creation-operation/creation-operation.component';
import {
  CreationOperationValueComponent
} from './creation-form/operations-form/creation-operation/creation-operation-value/creation-operation-value.component';
import { CheckListComponent } from './check-list/check-list.component';
import { FiltersFormComponent } from './filters-form/filters-form.component';
import { VisibleColumnsComponent } from './visible-columns/visible-columns.component';
import { GroupsCheckboxComponent } from './creation-form/groups-checkbox/groups-checkbox.component';
import { CondictionsDocumentsComponent } from './condictions-documents/condictions-documents.component';
import { MasterAccessControlComponent } from './creation-form/master-access-control/master-access-control.component';
import { CondictionsColumnsTableComponent } from './condictions-columns-table/condictions-columns-table.component';
import { CondictionsColumnsComponent } from './creation-form/condictions-columns/condictions-columns.component';
import { RadicationsDocumentsComponent } from './creation-form/radications-documents/radications-documents.component';
import { CheckListOptionsComponent } from './check-list/check-list-options/check-list-options.component';
import { SharedAdministrationModule } from '../shared-administration/shared-administration.module';
import { DataSourceComponent } from './creation-form/data-source/data-source.component';
import { SpecialOptionsComponent } from './special-options/special-options.component';
import { SpecialOptionsTableComponent } from './creation-form/special-options-table/special-options-table.component';
import { MultipleRecordsComponent } from './creation-form/multiple-records/multiple-records.component';
import { DefaultValuesComponent } from './creation-form/default-values/default-values.component';
import { DefaultValuesMasterComponent } from './creation-form/default-values-master/default-values-master.component';
import { DynamicFormsComponent } from './dynamic-forms/dynamic-forms.component';
import { DocumentFormComponent } from './document-form/document-form.component';
import { ProcedureComponent } from './creation-form/procedure/procedure.component';
import { TypeDocumentaryComponent } from './creation-form/type-documentary/type-documentary.component';
import { DocumentsComponent } from './creation-form/documents/documents.component';
import {
  OperationsConditionsFormComponent
} from './conditions/operations-condition-form/operations-condition-form.component';
import {
  CreationOperationConditionComponent
} from './conditions/operations-condition-form/creation-operation-condition/creation-operation-condition.component';
import {
  CreationOperationConditionValueComponent
} from './conditions/operations-condition-form/creation-operation-condition/creation-operation-condition-value/creation-operation-condition-value.component';
import { ComparisonNumbersComponent } from './creation-form/comparison-numbers/comparison-numbers.component';
import { FilterProcedureComponent } from './creation-form/filter-procedure/filter-procedure.component';
import { ModifyWindowComponent } from './modify-window/modify-window.component';


@NgModule({
  imports: [
    CommonModule,
    SharedAdministrationModule,
  ],
  declarations: [
    CreationDynamicComponentComponent,
    CreationFormComponent,
    ViewFormComponent,
    AssociationTaskFormsComponent,
    ConditionsComponent,
    OperationsFormComponent,
    CreationOperationComponent,
    CreationOperationValueComponent,
    CheckListComponent,
    FiltersFormComponent,
    VisibleColumnsComponent,
    GroupsCheckboxComponent,
    CondictionsDocumentsComponent,
    MasterAccessControlComponent,
    CondictionsColumnsTableComponent,
    CondictionsColumnsComponent,
    RadicationsDocumentsComponent,
    CheckListOptionsComponent,
    SpecialOptionsComponent,
    DataSourceComponent,
    SpecialOptionsTableComponent,
    MultipleRecordsComponent,
    DefaultValuesComponent,
    DefaultValuesMasterComponent,
    DynamicFormsComponent,
    DocumentFormComponent,
    ProcedureComponent,
    TypeDocumentaryComponent,
    DocumentsComponent,
    OperationsConditionsFormComponent,
    CreationOperationConditionComponent,
    CreationOperationConditionValueComponent,
    ComparisonNumbersComponent,
    FilterProcedureComponent,
    ModifyWindowComponent
  ]
})
export class CreationDynamicComponentModule { }



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/creation-dynamic-component.module.ts